export const SUPPORT_EMAIL = 'info@kimblegroup.com';

export const PROFILE_LOADER_TEXTS = [
  'Optimizing your professional story to attract top recruiters',
  'Designing a career profile that gets you noticed',
];

export const DEFAULT_LOADER_TEXTS = ['Collecting information', 'Organizing data'];

export const STUB_DEFAULT_TEXTS = {
  mainText: 'NO RESULTS FOUND',
  subText: "We can't find any job matching your search",
};

export const STUB_ERROR_TEXTS = {
  mainText: 'JOBS TEMPORARILY UNAVAILABLE',
  subText: "We can't load jobs right now. Please refresh the page in a minute",
};

export const HISTORY_STUB_TEXTS = {
  mainText: 'Nothing logged yet',
  subText: `Open any listing — from the digest email or on the board — and the recruiter writes it here, newest first. The log starts with your first click.`,
};

export const HISTORY_SEARCH_STUB_TEXTS = {
  mainText: 'NO RESULTS FOUND',
  subText: "We can't find any clicked job matching your search",
};

export const HOMEPAGE_QUESTIONS = [
  {
    title: 'What is an AI recruiter service?',
    text: 'The AI recruiter service is an advanced job search tool that uses artificial intelligence to curate job opportunities based on your specific attributes such as career path, skill set, location, job title, etc.',
  },
  {
    title: 'How does the AI recruiter work?',
    text: 'The AI recruiter utilizes machine learning algorithms to understand your profile and career preferences. It then matches these preferences with millions of job vacancies to suggest the most suitable opportunities for you.',
  },
  {
    title: 'How accurate are the job suggestions from the AI recruiter?',
    text: 'The accuracy of job suggestions depends highly on the quality of data provided by the job seekers. The more detailed and specific you are about your skills, career aims and preferences, the better the AI recruiter can perform in suggesting jobs that fit you.',
  },
  {
    title: 'How can I improve the quality of job suggestions?',
    text: 'To improve the quality of job suggestions, it is recommended to regularly update your profile with any new skills, job preferences, or career aspirations.',
  },
  {
    title: 'Will the AI recruiter notify me about new job opportunities?',
    text: 'Yes, once the AI recruiter finds a job match based on your preferences, it will notify you via email.',
  },
  {
    title: 'Can I apply directly through the AI recruiter service?',
    text: "Yes, our emails typically provide a direct link to the job posting or company's website where you can complete your application.",
  },
];
